"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOnboardingInformationResponseToJSON = exports.GetOnboardingInformationResponseFromJSONTyped = exports.GetOnboardingInformationResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function GetOnboardingInformationResponseFromJSON(json) {
    return GetOnboardingInformationResponseFromJSONTyped(json, false);
}
exports.GetOnboardingInformationResponseFromJSON = GetOnboardingInformationResponseFromJSON;
function GetOnboardingInformationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'signedUrlKey': json['signedUrlKey'],
        'email': !(0, runtime_1.exists)(json, 'email') ? undefined : json['email'],
        'phoneNumber': !(0, runtime_1.exists)(json, 'phoneNumber') ? undefined : (0, _1.PhoneNumberBodyFromJSON)(json['phoneNumber']),
        'firstName': !(0, runtime_1.exists)(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !(0, runtime_1.exists)(json, 'lastName') ? undefined : json['lastName'],
        'wallets': !(0, runtime_1.exists)(json, 'wallets') ? undefined : json['wallets'],
    };
}
exports.GetOnboardingInformationResponseFromJSONTyped = GetOnboardingInformationResponseFromJSONTyped;
function GetOnboardingInformationResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'signedUrlKey': value.signedUrlKey,
        'email': value.email,
        'phoneNumber': (0, _1.PhoneNumberBodyToJSON)(value.phoneNumber),
        'firstName': value.firstName,
        'lastName': value.lastName,
        'wallets': value.wallets,
    };
}
exports.GetOnboardingInformationResponseToJSON = GetOnboardingInformationResponseToJSON;
